import dayjs, { type Dayjs } from 'dayjs'

export const DATE_FORMAT = 'YYYY-MM-DD'

// Maps a quick-preset id to the `YYYY-MM-DD` value its lower bound implies.
// `null` means "no lower bound" (e.g. the historical `All` preset).
export function presetIdToDateFrom(presetId: string, asOf: Dayjs = dayjs()): string | null {
  switch (presetId) {
    case 'today':
      return asOf.format(DATE_FORMAT)
    case '2days':
      return asOf.subtract(2, 'day').format(DATE_FORMAT)
    case '7days':
      return asOf.subtract(7, 'day').format(DATE_FORMAT)
    case '30days':
      return asOf.subtract(30, 'day').format(DATE_FORMAT)
    case 'all':
    default:
      return null
  }
}

/**
 * Re-resolves an explicitly selected preset against the current day (PD-1206).
 * A null preset means the picker owns the range, even when those dates happen to
 * have the same shape as Today, 7 Days or 30 Days.
 */
export function resolvePresetRange(
  presetId: string | null,
  dateFrom: string | null,
  dateTo: string | null,
): { dateFrom: string | null; dateTo: string | null } {
  if (!presetId) return { dateFrom, dateTo }
  return {
    dateFrom: presetIdToDateFrom(presetId),
    dateTo: dayjs().format(DATE_FORMAT),
  }
}
